var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"wechat-title",rawName:"v-wechat-title",value:(this.title),expression:"this.title"}],attrs:{"id":"home"}},[_c('div',{staticClass:"content"})])}
var staticRenderFns = []

export { render, staticRenderFns }